/*
 * Copyright (c) 2026 Centrica.  All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * Date: 2026-10-19
 */
import { ColumnConfig } from 'nebula-ui-kit';

/**
 * Como pinta el kit los valores fuera de una tabla, con su `FormatService.formatValue`: la misma
 * forma que las columnas `currency` y `date` de las grillas, en un solo sitio (R-A11).
 *
 * <p>Sin valor, el kit escribe su guion de vacio; la moneda es la de la sesion o, si no hay, el
 * peso colombiano.</p>
 */

/** Moneda con dos decimales, como las columnas `currency` de las tablas. */
export const FORMATO_MONEDA: ColumnConfig<unknown> = {
  key: 'valor',
  label: '',
  pipe: 'currency',
  pipeArgs: { minimumFractionDigits: 2, maximumFractionDigits: 2 },
};

/** Fecha con el formato de la configuracion del kit (`dd/MM/yyyy` por defecto). */
export const FORMATO_FECHA: ColumnConfig<unknown> = { key: 'fecha', label: '', pipe: 'date' };
